import classNames from 'classnames';

import { Button, EmailField, InputField } from 'components';
import React, { FC } from 'react';
import { Field, Form } from 'react-final-form';
import {
  composeValidators,
  validateLinkedIn,
  validateName,
  validatePhone,
  validateRequired,
  validateUrl,
} from 'validations';

import './CreateListingLeadForm.styles.scss';

type CreateListingLeadFormProps = {
  onSubmit: (values: any) => void;
  submitInProgress?: boolean;
};

const CreateListingLeadForm: FC<CreateListingLeadFormProps> = (props) => {
  const { onSubmit, submitInProgress } = props;

  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className="create-listing-lead-form">
          <div
            className={classNames('create-listing-lead-form__fields', 'form')}
          >
            <EmailField label="Email *" />
            <Field
              name="first_name"
              label="First name *"
              component={InputField}
              placeholder="e.g. John"
              validate={composeValidators(
                validateRequired('First name is required.'),
                validateName(),
              )}
            />
            <Field
              name="last_name"
              label="Last name"
              component={InputField}
              placeholder="e.g. Doe"
              validate={validateName('Please enter a valid last name.')}
            />
            <Field
              name="title"
              label="Title"
              component={InputField}
              placeholder="e.g. Chief Executive Officer"
            />
            <Field
              name="company_name"
              label="Company name"
              component={InputField}
              placeholder="e.g. Edge & Node"
            />
            <Field
              name="phone"
              label="Phone"
              component={InputField}
              placeholder="e.g. +381 12 3456789"
              validate={validatePhone()}
            />
            <Field
              name="linkedin_url"
              label="Linkedin link"
              component={InputField}
              placeholder="https://www.linkedin.com/profile_name"
              validate={validateLinkedIn()}
            />
            <Field
              name="website_url"
              label="Website link"
              component={InputField}
              placeholder="https://ncodedsolutions.com"
              validate={validateUrl()}
            />
            <Field
              name="country"
              label="Country"
              component={InputField}
              placeholder="e.g. United States of America"
            />
            <Field
              name="city"
              label="City"
              component={InputField}
              placeholder="e.g. New York"
            />
            <Field
              name="keywords"
              label="Keywords"
              component={InputField}
              placeholder="e.g. frontend, engineer, electrical engineer, developer..."
            />
            <Field
              name="industry"
              label="Industry"
              component={InputField}
              placeholder="e.g. IT"
            />
            <Field
              name="companyLinkedinUrl"
              label="Company linkedin URL"
              component={InputField}
              placeholder="Paste the link to the company's linkedin"
              validate={validateLinkedIn()}
            />
          </div>

          <Button
            type="submit"
            className="submit-button"
            isLoading={submitInProgress}
          >
            Create
          </Button>
        </form>
      )}
    />
  );
};

export default CreateListingLeadForm;
